<template>
  <div class="column">
    <woot-modal-header :header-title="$t('AI.TOOLS.FILTERS.TITLE')">
      <p>{{ $t('AI.TOOLS.FILTERS.SUB_TITLE') }}</p>
    </woot-modal-header>
    <div class="row modal-content">
        <div class="small-12 medium-12 columns filters-wrap">
            <!-- :filter-groups="filterGroups"
            :grouped-filters="true" -->
            <filter-input-box
                v-for="(filter, i) in appliedFilters"
                :key="i"
                v-model="appliedFilters[i]"
                :filterAttributes="filterAttributes"
                :input-type="getInputType(appliedFilters[i].attribute_key)"
                :operators="getOperators(appliedFilters[i].attribute_key)"
                :dropdown-values="getDropdownValues(appliedFilters[i].attribute_key)"
                :show-query-operator="i !== appliedFilters.length - 1"
                :show-user-input="showUserInput(appliedFilters[i].filter_operator)"
                :v="$v.appliedFilters.$each[i]"
                @resetFilter="resetFilter(i, appliedFilters[i])"
                @removeFilter="removeFilter(i)"
            />
            <div class="filter-actions">
            <woot-button
                icon="add"
                variant="smooth"
                size="small"
                @click="appendNewFilter"
            >
                {{ $t('CONTACTS_FILTER.ADD_NEW_FILTER') }}
            </woot-button>
                <!-- v-if="hasAppliedFilters" -->
            <woot-button
                icon="subtract"
                color-scheme="alert"
                variant="smooth"
                size="small"
                @click="clearFilters"
            >
                {{ $t('CONTACTS_FILTER.CLEAR_ALL_FILTERS') }}
            </woot-button>
            </div>
        </div>

        <div class="small-12 medium-12 columns">
            <div class="modal-footer justify-content-end w-full">
            <woot-button class="button clear" @click.prevent="onClose">
                {{ $t('CONTACTS_FILTER.CANCEL_BUTTON_LABEL') }}
            </woot-button>
            <woot-button @click="submitFilterQuery">
                {{ $t('CONTACTS_FILTER.SUBMIT_BUTTON_LABEL') }}
            </woot-button>
            </div>
        </div>

    </div>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import { required, requiredIf } from 'vuelidate/lib/validators';
import FilterInputBox from 'components/widgets/FilterInput/Index.vue';
import countries from 'shared/constants/countries.js';
import { mapGetters } from 'vuex';
// import {EVALUATION_TYPES,EVALUATION_TYPE,EVALUATION_TYPES_INT,EVALUATION_REPORT_TYPES,} from "./evaluationConstant";
import {TOOL_TYPE_LIST} from "../ai.constant"
import filterMixin from 'shared/mixins/filterMixin';

export default {
    components: {
        FilterInputBox,
    },
    mixins: [alertMixin, filterMixin],
    props: {
        onClose: {
            type: Function,
            default: () => {},
        },
        filterItems: {
            type: Array,
            default: () => [],
        },
        initialAppliedfilters: {
            type: Array,
            default: () => [],
        },
        filterAttributes: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            show: true,
            appliedFilters:  [
                {
                    attribute_key: 'name',
                    filter_operator: 'equal_to',
                    values: '',
                    query_operator: 'and',
                }
            ],
            filterTypes: this.filterItems,
            filterGroups: [],
            // allCustomAttributes: [],
            // filterAttributeGroups,
        };
    },
    validations: {
        appliedFilters: {
            required,
            $each: {
                values: {
                    required: requiredIf(prop =>{
                        return !(
                        prop.filter_operator === 'is_present' ||
                        prop.filter_operator === 'is_not_present'
                        )
                    }),
                },
            },
        },
    },
    mounted(){
        console.log("mounted modal");
        if (this.initialAppliedfilters?.length) {
            this.appliedFilters = this.initialAppliedfilters;
        }
    },
    methods:{
        submitFilterQuery() {
            this.$v.$touch();
            if (this.$v.$invalid) return;
            // this.$store.dispatch(
            //     'contacts/setContactFilters',
            //     JSON.parse(JSON.stringify(this.appliedFilters))
            // );
            this.$emit('applyFilter', this.appliedFilters);
        },
        getInputType(key) {
            const type = this.filterTypes.find(filter => filter.attributeKey === key);
            return type.inputType;
        },
        getOperators(key) {
            const type = this.filterTypes.find(filter => filter.attributeKey === key);
            return type.filterOperators;
        },
        getDropdownValues(type) {
            switch (type) {
                case 'type':
                return TOOL_TYPE_LIST.map(el=>({...el,name:this.$t(el.title)}));
                // case 'result':
                // return EVALUATION_RESULT_TYPES.map(el=>({...el,name:this.$t(el.title)}));
                default:
                return undefined;
            }
        },
        showUserInput(operatorType) {
            if (operatorType === 'is_present' || operatorType === 'is_not_present')
                return false;
            return true;
        },
        resetFilter(index, currentFilter) {
            this.appliedFilters[index].filter_operator = this.filterTypes.find(
                filter => filter.attributeKey === currentFilter.attribute_key
            ).filterOperators[0].value;
            this.appliedFilters[index].values = '';
        },
        removeFilter(index) {
            if (this.appliedFilters.length <= 1) {
                this.showAlert(this.$t('CONTACTS_FILTER.FILTER_DELETE_ERROR'));
            } else {
                this.appliedFilters.splice(index, 1);
            }
        },
        appendNewFilter() {
            // attribute_key: name, agent_name
            if (this.isReportFilter) {
                this.appliedFilters.push({
                    attribute_key: 'result',
                    filter_operator: 'equal_to',
                    values: '',
                    query_operator: 'and',
                });
            }else{
                this.appliedFilters.push({
                    attribute_key: 'name',
                    filter_operator: 'equal_to',
                    values: '',
                    query_operator: 'and',
                });
            }
        },
        clearFilters() {
            this.$emit('clearFilters');
            this.onClose();
        },
        // methods end
    },
}
</script>

<style>

</style>